import { connect } from 'react-redux';
import { IReduxRootState } from '../../app/reduxRootState.interface';
import CancelMembership from './CancelMembership';
import { CancelMembershipActions } from './cancelmembershipActions';
import { ThunkDispatch } from 'redux-thunk';
import { CancelMembershipAction } from './cancelmembershipActionType';
import { IMemberInfo } from './cancelMemberState';

const mapStateToProps = (state: IReduxRootState) => {
    const { cancelMemberStaticUrl, cancelMemberPrefix } = state.app.clientConfig;

    const externalPointUrl = cancelMemberStaticUrl.extPoint ?? '';
    const twExternalPointUrl = cancelMemberStaticUrl.twExtPoint ?? '';
    const customExtPoint = cancelMemberStaticUrl.customExtPoint ?? '';
    const clientPrefix = cancelMemberPrefix?.clientPrefix ?? [];
    const { deletingAccount, deleteAccountError } = state.cancelMembership;

    const member = state.member as IMemberInfo;
    const locale = state.app.locale;
    return {
        challengerPid: state.app.appConfig.CHALLENGER_ENABLED
            ? state.app.appConfig.CHALLENGER_PIDS.CANCEL_MEMBERSHIP
            : '',
        cancelMembershipOverlayOpen: state.cancelMembership.cancelMembershipOverlayOpen,
        member: member,
        memberLoggedIn: state.app.memberLoggedIn,
        externalPointUrl: externalPointUrl,
        twExternalPointUrl: twExternalPointUrl,
        deleting: deletingAccount,
        apiError: deleteAccountError,
        locale,
        contentPrefix: state.app.presentationConfig['cancel.membership.content'],

        customExtPoint: customExtPoint,
        clientPrefix: clientPrefix,
    };
};

const mapDispatchToProps = (
    dispatch: ThunkDispatch<IReduxRootState, {}, CancelMembershipAction>,
) => {
    return {
        closeCancelMembershipOverlay: () =>
            dispatch(CancelMembershipActions.closeCancelMembershipOverlay()),
        deleteAccount: (member: IMemberInfo, challengerPid: string) => {
            dispatch(CancelMembershipActions.cancelMembership(member, challengerPid));
        },
        openCancelMembershipOverlay: () =>
            dispatch(CancelMembershipActions.openCancelMembershipOverlay()),
        startDeleteAccount: () => {
            dispatch(CancelMembershipActions.startDeleteAccount());
        },
        cancelMemberGoBack: () => {
            dispatch(CancelMembershipActions.cancelMemberGoBack());
        },
    };
};

const CancelMembershipContainer = connect(mapStateToProps, mapDispatchToProps)(CancelMembership);

export default CancelMembershipContainer;
